const _version = "2.12.6"
function version() {
    return _version
}
export default version
